import { render, staticRenderFns } from "./WrongQuestionPracticeConfigDialog.vue?vue&type=template&id=25ef0f62&scoped=true"
import script from "./WrongQuestionPracticeConfigDialog.vue?vue&type=script&lang=js"
export * from "./WrongQuestionPracticeConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./WrongQuestionPracticeConfigDialog.vue?vue&type=style&index=0&id=25ef0f62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ef0f62",
  null
  
)

export default component.exports